import { buildHtml, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { buildDrupalImage } from '../Image';

export function mapImageWithCaption(
  input: ImageWithCaptionFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'Figure'> {
  return {
    key: 'Figure',
    input: {
      Caption: buildHtml(input.caption || ''),
      Image: buildDrupalImage(input.image, 'content'),
    },
  };
}
